import instance from '@/utils/axios';

/**
 * 上传图片
 * @param {File[]} files
 */
export function uploadImage(files) {
  return instance.post('/devicedata/upload', files);
}
